import { accessSteps } from '@/mocks/nav';

export default function AccessGuide() {
  return (
    <section id="guide" className="w-full bg-background-100 py-20 md:py-28">
      <div className="w-full max-w-content mx-auto px-4 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12">
          <div className="lg:col-span-4">
            <span className="font-label text-xs tracking-[0.28em] text-accent-600">ACCESS GUIDE</span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
              导航打不开
              <br />
              这样进
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              大部分访问问题都能靠四步解决。别急着换搜索引擎反复找旧地址，先按下面顺序试一遍，通常一两分钟就能恢复。
            </p>

            <div className="mt-8 w-full rounded-lg overflow-hidden border border-background-200/70">
              <div className="w-full h-44 md:h-52">
                <img
                  src="https://readdy.ai/api/search-image?query=stylized%20abstract%20illustration%20of%20a%20troubleshooting%20checklist%20flow%2C%20warm%20amber%20and%20terracotta%20arrow%20shapes%20on%20cream%20paper%20background%2C%20minimal%20editorial%20magazine%20style%2C%20soft%20grain%2C%20no%20text&width=800&height=600&seq=nav-guide-banner&orientation=landscape"
                  alt="导航打不开时的排查流程示意"
                  title="51导航打不开 排查指引"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-4 bg-background-50">
                <p className="text-xs md:text-sm font-label text-foreground-600">
                  <i className="ri-lightbulb-flash-line text-primary-600 mr-1.5"></i>
                  小提示：无痕模式能打开，多半是本地缓存或插件的问题。
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
              {accessSteps.map((step, index) => (
                <article
                  key={step.step}
                  className={`rounded-lg p-6 md:p-7 border flex flex-col ${
                    index === 0
                      ? 'bg-primary-500 border-primary-500 text-background-50'
                      : 'bg-background-50 border-background-200/70'
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <span
                      className={`w-11 h-11 flex items-center justify-center rounded-lg text-lg ${
                        index === 0 ? 'bg-background-50/20 text-background-50' : 'bg-background-100 text-primary-600'
                      }`}
                    >
                      <i className={step.icon}></i>
                    </span>
                    <span
                      className={`font-heading text-3xl ${
                        index === 0 ? 'text-background-50/50' : 'text-background-300'
                      }`}
                    >
                      {step.step}
                    </span>
                  </div>
                  <h3
                    className={`mt-5 font-heading text-lg font-bold ${
                      index === 0 ? 'text-background-50' : 'text-foreground-950'
                    }`}
                  >
                    {step.title}
                  </h3>
                  <p
                    className={`mt-2.5 text-sm leading-relaxed ${
                      index === 0 ? 'text-background-50/85' : 'text-foreground-600'
                    }`}
                  >
                    {step.desc}
                  </p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}